var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"area-detail"}},[_c('div',{staticClass:"page-content",attrs:{"id":"page-content"}})])
}]

export { render, staticRenderFns }